import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import OutsideNotifier from 'js/components/outside_notifier/index';

import './index.scss';

export default class OptionsDropdown extends Component {
    static propTypes = {
        onChange: PropTypes.func,
        defaultOpen: PropTypes.bool,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.any,
                label: PropTypes.any
            })
        ),
        selected: PropTypes.any,
        label: PropTypes.string,
        leftIcon: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            selected: props.selected,
            open: !!props.defaultOpen,
            optionsById: R.pipe(
                R.map(option => [option.id, option.label]),
                R.fromPairs
            )(props.options)
        };
    }

    onClose = () => {
        this.setState({open: false});
    };

    onChange(option) {
        this.setState({
            selected: option,
            open: false
        });

        if (this.props.onChange) {
            this.props.onChange(option);
        }
    }

    toggleOpen = () => {
        this.setState({open: !this.state.open});
    };

    renderOption = ({id, label}) => (
        <div key={id} className="options-dropdown__option" onClick={() => this.onChange(id)}>
            {label}
        </div>
    );

    renderOptions() {
        if (this.state.open) {
            const {options} = this.props;
            return (
                <div className="options-dropdown__options">{R.map(this.renderOption, options)}</div>
            );
        }
    }

    render() {
        const {selected, optionsById} = this.state;
        const {width, label} = this.props;

        return (
            <OutsideNotifier onClickOutsideChildren={this.onClose}>
                <div className="options-dropdown" style={{width}}>
                    <div className="options-dropdown__control" onClick={this.toggleOpen}>

                        {this.props.leftIcon && <div className='options-dropdown__left-icon'>
                            <img src={this.props.leftIcon} alt="dropdown left icon" />
                        </div>}

                        <div className="options-dropdown__text">
                            {label || optionsById[selected]}
                        </div>
                    </div>
                    {this.renderOptions()}
                </div>
            </OutsideNotifier>
        );
    }
}



// WEBPACK FOOTER //
// ./components/options_dropdown/index.js